import React, { useState, useEffect } from 'react';
import Tiles from './Tiles';
import Charts from '../Dashboards/Charts';
import '../Dashboards/DashboardStyle.css';
import FuelSlabChart from '../Dashboards/FuelSlabChart';
import UserRegistrationChart from '../Dashboards/UserRegistrationChart';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import qs from "qs";
import { useRO } from "./ROContext";
import ROSelect from "./ROSelect";
import RangeSelect from "./RangeSelect";


const API_BASE_URL = "https://api.drivergems.com";

function generateSignature(method, urlPath, timestamp) {
  const secretKey = "jnpkXDAM1GBvyDxYITtukz43zekx6UXgpipODwW9KY5";
  const message = `${method}${urlPath}${timestamp}`;
  return CryptoJS.HmacSHA256(message, secretKey).toString(CryptoJS.enc.Hex);
}

const Dashboard = () => {
  const [registeredUserData, setRegisteredUserData] = useState([]);
  const [selectedRange, setSelectedRange] = useState('1week');
  const [fuelTransactions, setFuelTransactions] = useState([]);
  const [visibleFuels, setVisibleFuels] = useState({
    Diesel: true,
    Petrol: true,
    CNG: true,
    SpeedPetrol: true,
    LPG: true,
    Electric: true,
  });

  const [availableFuels, setAvailableFuels] = useState([
    'Diesel',
    'Petrol',
    'CNG',
    'Speed Petrol',
    'LPG',
    'Electric',
  ]);
const { roList, selectedRoId, setSelectedRoId } = useRO(); 
  const [setRoList] = useState([]);
 // const [selectedRoId, setSelectedRoId] = useState(null);
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    const savedRoId = localStorage.getItem('selectedRoId');
    if (savedRoId) {
      setSelectedRoId(savedRoId);
    }

    const fetchRoList = async () => {
      const timestamp = Math.floor(Date.now() / 1000).toString();
      const userUrlPath = "/v1/user/ros";
      const userSignature = generateSignature("GET", userUrlPath, timestamp);
  
      try {
        const response = await axios.get(`${API_BASE_URL}${userUrlPath}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Signature": userSignature,
            "X-Timestamp": timestamp,
          },
        });
  
        if (response.data.ro_list && response.data.ro_list.length > 0) {
          setRoList(response.data.ro_list);
  
          const savedRoId = localStorage.getItem("selectedRoId");
          const foundInList = response.data.ro_list.find(ro => ro.id === savedRoId);
  
          if (savedRoId && foundInList) {
            setSelectedRoId(savedRoId);
          } else {
            const defaultRoId = response.data.ro_list[0].id;
            setSelectedRoId(defaultRoId);
            localStorage.setItem("selectedRoId", defaultRoId);
          }
        }
      } catch (error) {
        console.error("Error fetching RO list:", error);
      }
    };

    fetchRoList();
  }, []);

  const handleToggle = (type) => {
    const key = type === "Speed Petrol" ? "SpeedPetrol" : type;
    setVisibleFuels(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const handleRoChange = (event) => {
    const newRoId = event.target.value;
    setSelectedRoId(newRoId);
    localStorage.setItem('selectedRoId', newRoId);
  };

  const fetchFuelData = async () => {
    const today = new Date();
    const past = new Date(today);
    switch (selectedRange) {
      case "1week": past.setDate(today.getDate() - 6); break;
      case "1month": past.setMonth(today.getMonth() - 1); break;
      case "3month": past.setMonth(today.getMonth() - 3); break;
      case "6month": past.setMonth(today.getMonth() - 6); break;
    }

    const start_date = new Date(past.setHours(0, 0, 0, 0)).toISOString();
    const end_date = new Date(today.setHours(23, 59, 59, 999)).toISOString();

    const method = "GET";
    const urlPath = "/v2/user/transactions/fuel/range";
    const timestamp = Math.floor(Date.now() / 1000).toString();
    const signature = generateSignature(method, urlPath, timestamp);

    try {
      const response = await axios.get(
        `${API_BASE_URL}${urlPath}?${qs.stringify({ start_date, end_date })}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Signature": signature,
            "X-Timestamp": timestamp,
          },
        }
      );
      
      const data = Array.isArray(response.data.transactions)
        ? response.data.transactions
        : Array.isArray(response.data)
          ? response.data
          : [];

      setFuelTransactions(data);
    } catch (error) {
      console.error("Failed to fetch fuel data", error);
    }
  };

  // Fetch referred users data
  const fetchReferredUsersData = async () => {
    const today = new Date();
    const past = new Date(today);
    switch (selectedRange) {
      case "1week": past.setDate(today.getDate() - 6); break;
      case "1month": past.setMonth(today.getMonth() - 1); break;
      case "3month": past.setMonth(today.getMonth() - 3); break;
      case "6month": past.setMonth(today.getMonth() - 6); break;
    }

    const start_date = new Date(past.setHours(0, 0, 0, 0)).toISOString();
    const end_date = new Date(today.setHours(23, 59, 59, 999)).toISOString();

    const timestamp = Math.floor(Date.now() / 1000).toString();
    const apiUrl = `/v1/user/consumerdetails/referredbyme`;
    const signature = generateSignature("GET", apiUrl, timestamp);

    try {
      const response = await axios.get(
        `${API_BASE_URL}${apiUrl}?${qs.stringify({ start_date, end_date })}`,
        {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Signature": signature,
          "X-Timestamp": timestamp,
        },
      });

      const users = Array.isArray(response.data.users) ? response.data.users : [];
      if (users.length > 0) {
        setRegisteredUserData(users);
      } else {
        setRegisteredUserData([]);
      }
    } catch (err) {
      console.error("Failed to fetch referred users data", err);
    }
  };

  useEffect(() => {
    if (selectedRoId) {
      fetchFuelData();
      fetchReferredUsersData();
    }
  }, [selectedRange, selectedRoId]);

  return (
      <div className="dashboardcontainer">
      <div className="ro-selector-container" style={{ padding:"3px" }}>
        <div
  className="ro-dropdown"
  style={{
    display: "flex",
    alignItems: "flex-end",   // 🔥 IMPORTANT
    gap: "14px",
  }}
>              <ROSelect className="roSelectInline" labelClassName="roLable" />

         <RangeSelect
  value={selectedRange}
  onChange={(e) => setSelectedRange(e.target.value)}
/>


          {["Diesel", "Petrol", "CNG", "Speed Petrol", "LPG", "Electric"]
            .filter(fuel => availableFuels.includes(fuel))
            .map(fuel => {
              const key = fuel === "Speed Petrol" ? "SpeedPetrol" : fuel;
              return (
                <label key={fuel} style={{ marginLeft: "10px", color:"white" }}>
                  <input
                    type="checkbox"
                    className="custom-checkbox"
                    checked={visibleFuels[key]}
                    onChange={() => handleToggle(fuel)}
                  />
                  {fuel}
                </label>
              );
            })}
        </div>
      </div>


        <Tiles
          token={token}
          selectedRoId={selectedRoId}
          data={fuelTransactions}
          visibleFuels={visibleFuels} />

        <Charts
          data={fuelTransactions}
          selectedRange={selectedRange}
          visibleFuels={visibleFuels}
          setAvailableFuels={setAvailableFuels} />

        <div className="chart-container-2" style={{ display: "flex" }}>
          <FuelSlabChart
            data={fuelTransactions}
            visibleFuels={visibleFuels}
            selectedRange={selectedRange} />
          <UserRegistrationChart
            data={registeredUserData}
            selectedRange={selectedRange} />
        </div>
      </div>
  );
};

export default Dashboard;
